/* React */
import React, { useState, useEffect } from "react";

/* React Router */
import { useLocation } from "react-router";

/* Ionic */
import { IonItem, IonIcon } from "@ionic/react";

/* Font Awesome */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

/* Stylesheet */
import styles from "./NavItem.module.scss";

/* Interfaces */
import { NavItemProps } from "src/shared/interfaces/common/NavItem";

interface NavContainerProps {
  scssProps?: ScssProps;
  item: NavItemProps;
  showLines?: boolean;
  showName?: boolean;
  disabled?: boolean;
  onClick?: (value: boolean) => void;
}

interface ScssProps {
  paddingStart?: string;
  width?: string;
  activeColor?: string;
  borderRadius?: string;
}

const NavItem: React.FC<NavContainerProps> = ({
  scssProps,
  item,
  showLines,
  showName,
  disabled,
  onClick,
}) => {
  const path = useLocation();

  const [currentPath, setCurrentPath] = useState<string>(
    path.pathname
  );

  useEffect(() => {
    setCurrentPath(path.pathname);
  }, [path]);

  const isActive =
    currentPath === item.path ||
    currentPath.startsWith(`${item.path}/`);

  const renderIcon = () => {
    if (item.icon) {
      if (typeof item.icon === "string") {
        return (
          <IonIcon
            className={styles.icon}
            icon={item.icon}
            slot="start"
          />
        );
      } else {
        return (
          <FontAwesomeIcon
            className={styles.icon}
            icon={item.icon as IconDefinition}
          />
        );
      }
    }
    return null;
  };

  return (
    <IonItem
      style={{
        "--padding-start": scssProps?.paddingStart,
        width: scssProps?.width,
        "--background": isActive
          ? scssProps?.activeColor
          : undefined,
        borderRadius: scssProps?.borderRadius,
      }}
      aria-label={item.name}
      className={styles.nav_item}
      lines={showLines ? "full" : "none"}
      disabled={disabled}
      routerLink={item.path}
      onClick={() => {
        onClick?.(false);
      }}
      button
    >
      {renderIcon()}
      {showName ? item.name : undefined}
    </IonItem>
  );
};

export default NavItem;
